//emailJS 월 200건
//계정 : noreply@daom04.com

// POST
// https://api.emailjs.com/api/v1.0/email/send

import axios from 'axios';

let sendMail = function(name, email, phone, msg){
    let url = "https://api.emailjs.com/api/v1.0/email/send";
    let emailJson = {
        "service_id" : "service_6oajrnz",
        "template_id": "template_ubh1ssg",
        "user_id" : "gqSimnzmZXgIGcl0W",
        "template_params" : {
            "name" : name
            ,"email" : email
            ,"phone" : phone
            ,"msg" : msg
        }
    }

    axios.post(url, emailJson)
        .then(response => {
          console.log('이메일 전송 성공:', response);
        })
        .catch(error => {
          console.error('이메일 전송 실패:', error);
        });

}

export default { sendMail }